export const throttle = <TFunctionParam>(callback: (...args: TFunctionParam[]) => unknown, timeFrame: number): ((...args: TFunctionParam[]) => void) => {
    let lastTime = 0;
    let requestId: number | null = null;

    return (...args: TFunctionParam[]) => {
        const now = Date.now();

        if (!requestId && now - lastTime >= timeFrame) {
            requestId = window.requestAnimationFrame(() => {
                callback(...args);
                lastTime = now;
                requestId = null;
            });
        }
    };
};
export const throttle = <TFunctionParam>(callback: (...args: TFunctionParam[]) => unknown, timeFrame: number): ((...args: TFunctionParam[]) => void) => {
    let lastTime = 0;
    let requestId: number | null = null;

    return (...args: TFunctionParam[]) => {
        const now = Date.now();

        if (!requestId && now - lastTime >= timeFrame) {
            requestId = window.requestAnimationFrame(() => {
                callback(...args);
                lastTime = now;
                requestId = null;
            });
        }
    };
};
